import { render } from "./Slider.vue?vue&type=template&id=ec573670&bindings={\"currentSlide\":\"data\",\"sliders\":\"data\",\"interval\":\"data\",\"isTitleShowing\":\"data\",\"makeActive\":\"options\"}"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script